import { styled } from '@mui/material'

export const Overlay = styled('div')(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.grey[500],
}))
